import type { AssistantSupportResult } from './assistant.models';
import type { SupportCredentials } from './connect-chat-client';

export function parseSupportCredentials(value: unknown): SupportCredentials {
  if (!isRecord(value)) throw new Error('Invalid support credentials');
  for (const key of ['contactId', 'participantId', 'participantToken', 'region']) {
    if (typeof value[key] !== 'string' || !value[key] || (value[key] as string).length > 2000)
      throw new Error('Invalid support credentials');
  }
  if (!/^[a-z]{2}(?:-[a-z]+)+-\d+$/.test(value['region'] as string))
    throw new Error('Invalid support region');
  const contextMessageIds = value['contextMessageIds'];
  if (contextMessageIds !== undefined && (!Array.isArray(contextMessageIds) ||
      contextMessageIds.some(id => typeof id !== 'string' || !id || id.length > 200)))
    throw new Error('Invalid handoff context identifiers');
  const initialContextMessage = value['initialContextMessage'];
  if (initialContextMessage !== undefined && initialContextMessage !== null &&
      (typeof initialContextMessage !== 'string' || initialContextMessage.length > 4096))
    throw new Error('Invalid handoff context');
  return { ...(Array.isArray(contextMessageIds) ? { contextMessageIds: [...contextMessageIds] } : {}), ...(typeof initialContextMessage === 'string' && initialContextMessage
    ? { initialContextMessage } : {}), contactId: value['contactId'] as string, participantId: value['participantId'] as string,
    participantToken: value['participantToken'] as string, region: value['region'] as string };
}

export function parseSupport(value: unknown): AssistantSupportResult {
  if (!isRecord(value) || typeof value['handoffId'] !== 'string' ||
      !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value['handoffId']))
    throw new Error('Invalid support result');
  const handoffId = value['handoffId'];
  if (value['ended'] === true) return { handoffId, ended: true };
  return { ...parseSupportCredentials(value), handoffId };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
